import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {MonitoringRoutingModule} from './monitoring-routing.module';
import {MonitoringComponent} from './monitoring.component';
import {MonitoringWithMapModule} from './monitoring-with-map/monitoring-with-map.module';
import {UserInfoModule} from '../../shared/components/user-info/user-info.module';
import {NgxMaskModule} from 'ngx-mask';


@NgModule({
  declarations: [MonitoringComponent],
  imports: [
    CommonModule,

    MonitoringRoutingModule,
    UserInfoModule,
    MonitoringWithMapModule,
    NgxMaskModule.forRoot(),

  ]
})
export class MonitoringModule {
}
